<template>
  <v-container>
    <hr class="spacer md">
    <v-layout>
      <v-flex md6>
        <h1 class="primary--text">
          TYPOGRAPHY - ENCODE SANS
        </h1>
        <hr class="spacer">
        <h1>Title H1 - 24px</h1>
        <h2>Title H2 - 18px</h2>
        <h3>Title H3 - 16px</h3>
        <p>Body 1 loren ipsum - 14px</p>
        <p class="caption">
          Caption loren ipsum - 12px
        </p>
      </v-flex>
      <v-flex md6>
        <h1 class="primary--text">
          PRIMARY COLORS
        </h1>
        <v-layout>
          <v-flex md2>
            <div class="square black" />
            <p>#000000</p>
          </v-flex>
          <v-flex md2>
            <div class="square white" />
            <p>#FFFFFF</p>
          </v-flex>
          <v-flex md2>
            <div class="square primary" />
            <p>#1E398D</p>
          </v-flex>
          <v-flex md2>
            <div class="square secondary" />
            <p>#FCE300</p>
          </v-flex>
        </v-layout>
        <hr class="spacer md">
        <h2 class="primary--text">
          SECONDARY COLORS
        </h2>
        <v-layout>
          <v-flex md2>
            <div class="square primary--light" />
            <p>#2196F3</p>
          </v-flex>
          <v-flex md2>
            <div class="square dark" />
            <p>#424242</p>
          </v-flex>
          <v-flex md2>
            <div class="square light" />
            <p>#EEEEEE</p>
          </v-flex>
          <v-flex md2>
            <div class="square success" />
            <p>#4CAF50</p>
          </v-flex>
          <v-flex md2>
            <div class="square alert" />
            <p>#FF5252</p>
          </v-flex>
          <v-flex md2>
            <div class="square highlight" />
            <p>#FFC107</p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <hr class="spacer md">
    <hr class="sep">
    <hr class="spacer md">
    <v-layout>
      <v-flex md6>
        <h1 class="primary--text">
          BUTTONS
        </h1>
        <h2 class="primary--text">
          btn
        </h2>
        <v-btn
          color="primary"
          rounded
        >
          Primary
        </v-btn>
        <hr class="spacer">
        <v-btn
          text
        >
          Secondary
        </v-btn>
        <hr class="spacer md">
        <h2 class="primary--text">
          Dropdown
        </h2>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              rounded
              v-on="on"
            >
              Primary
              <v-icon>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <hr class="spacer md">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              v-on="on"
            >
              <span>Secondary</span>
              <v-icon>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <hr class="spacer md">
        <hr class="spacer md">
        <h2 class="primary--text">
          Radio button -  Checkbox - Toggle
        </h2>
        <v-radio-group
          v-model="radios"
          row
        >
          <v-radio
            value="radio-1"
          />
          <v-radio
            value="radio-2"
          />
        </v-radio-group>
        <div style="display: flex">
          <v-checkbox />
          <v-checkbox
            :input-value="true"
          />
        </div>
        <div style="display: flex">
          <v-switch inset />
          <v-switch
            :input-value="true"
            inset
          />
        </div>
      </v-flex>
      <v-flex
        md6
      >
        <h1 class="primary--text">
          SYSTEM ICONS
        </h1>
        <hr class="spacer md">
        <v-layout
          wrap
          class="icons"
        >
          <v-flex md1>
            <v-icon>mdi-email</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-bell</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-forum</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-equalizer</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-barcode</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-file-document</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-shield-check</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-alert-circle</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-account</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-logout</v-icon>
          </v-flex>
        </v-layout>
        <hr class="spacer">
        <v-layout
          wrap
          class="icons"
        >
          <v-flex md1>
            <v-icon>mdi-account-group</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-eye-off</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-chevron-left</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-pencil</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-alert</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-check-bold</v-icon>
          </v-flex>
          <v-flex md1>
            <v-icon>mdi-close</v-icon>
          </v-flex>
        </v-layout>
        <hr class="spacer md">
        <hr class="spacer md">
        <h1 class="primary--text">
          FORMS
        </h1>
        <v-form
          ref="form"
        >
          <v-text-field
            label="Label"
            placeholder="Placeholder"
          />
          <v-text-field
            append-icon="mdi-eye-off"
            type="password"
            name="input-10-1"
            label="Label"
            value="Input text |"
          />
          <v-text-field
            label="Label"
            value="Input text |"
            append-icon="mdi-pencil"
            @click:append="nothing"
          />
          <v-text-field
            name="input-10-2"
            label="Label"
            hint="Feedback erro"
            value="Input"
            error
          />
        </v-form>
      </v-flex>
    </v-layout>
    <hr class="spacer md">
    <hr class="sep">
    <hr class="spacer md">
    <v-layout>
      <v-flex md12>
        <h1 class="primary--text">
          LISTS
        </h1>
        <v-data-table
          :headers="headers"
          :items="desserts"
          hide-default-footer
          disable-sort
          sort-by="calories"
          class="elevation-1"
        >
          <template v-slot:item.action="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-icon>mdi-pencil</v-icon>
                    Lorem
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-icon>mdi-delete</v-icon>
                    Ipsum
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <hr class="spacer bg">
    <v-layout>
      <v-flex md6>
        <v-card class="atencao">
          <v-card-title>
            <v-icon>mdi-alert</v-icon>
            Modal de Alerta
          </v-card-title>
          <v-card-text>
            Loren Ipsum Doler Ipsum Loren Ipsum Doler
            Ipsum Loren Ipsum Doler Ipsum Loren Ipsum Doler Ipsum?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text>
              Cancelar
            </v-btn>
            <v-btn
              rounded
              large
              color="primary"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
        <hr class="spacer md">
        <v-card>
          <v-card-title>
            Modal de edição de informação
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form"
            >
              <v-text-field
                label="Label"
                placeholder="Placeholder"
              />
              <v-text-field
                label="Label"
                placeholder="Placeholder"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text>
              Cancelar
            </v-btn>
            <v-btn
              rounded
              large
              color="primary"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <hr class="spacer md">
      <v-flex md6>
        <v-alert
          v-model="alert"
          close-text="Close Alert"
          color="success"
          dark
          dismissible
        >
          <v-icon>
            mdi-check-bold
          </v-icon>
          Feedback de sucesso
        </v-alert>
        <hr class="spacer md">
        <v-alert
          v-model="alert"
          close-text="Close Alert"
          color="error"
          dark
          dismissible
        >
          <v-icon>
            mdi-check-bold
          </v-icon>
          Feedback de sucesso
        </v-alert>
      </v-flex>
    </v-layout>
    <hr class="spacer md">
  </v-container>
</template>

<script>
import Gateway from '@/services/gateway';
// import OrsegupsID from '@/services/orsegupsID';

export default {
  name: 'About',
  data: () => ({
    items: [
      { title: 'Item 1' },
      { title: 'Item 2' },
    ],
    headers: [
      { text: 'Item', sortable: false, value: 'name' },
      { text: 'Item', sortable: false, value: 'name1' },
      { text: 'Item', sortable: false, value: 'name2' },
      {
        text: '', value: 'action', sortable: false, align: 'right',
      },
    ],
    desserts: [
      {
        name: 'Lorem Ipsum',
        name1: 'Lorem Ipsum',
        name2: 'Lorem Ipsum',
      },
      {
        name: 'Lorem Ipsum',
        name1: 'Lorem Ipsum',
        name2: 'Lorem Ipsum',
      },
      {
        name: 'Lorem Ipsum',
        name1: 'Lorem Ipsum',
        name2: 'Lorem Ipsum',
      },
    ],
    radios: 'radio-2',
    alert: true,
  }),
  mounted() {
    // ping gateway
    Gateway.get();

    // TODO: ping mobile

    // FIXME: ping orsegups id
    // OrsegupsID.get();
  },
  methods: {
    nothing() {},
  },
};
</script>
<style lang="stylus">
  .square {
    width: 80px;
    height: 80px;
    border: 1px solid #efefef;
    margin-bottom: 5px;
  }
  .square.white {
    box-shadow: 0px 2px 5px 1px rgba(0,0,0,.3);
  }
  .icons .v-icon.v-icon {
    font-size: 36px
  }
</style>
